import { TenantTheme } from '../tenants/unbrace';

const showMoreTheme = (theme: TenantTheme) => ({
  color: theme.palette.primary.shade4,
});

export default showMoreTheme;
